import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const buttonClick = (isEnabled, onClick) => () => {
    if (isEnabled) {
        onClick();
    }
};

const Button = ({ children, cssClasses, isEnabled, onClick }) => {
    const buttonClasses = classNames('dashboard-btn', {
        [cssClasses]: Boolean(cssClasses),
    });

    return (
        <button type="button" onClick={buttonClick(isEnabled, onClick)} className={buttonClasses}>
            {children}
        </button>
    );
};

Button.propTypes = {
    children: PropTypes.node,
    cssClasses: PropTypes.string,
    isEnabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

Button.defaultProps = {
    cssClasses: '',
    isEnabled: true,
    children: '',
};

export default Button;
